import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NavController, NavParams, Events, Content } from 'ionic-angular';
import { BrComDao } from '../../service/BrComDao';
import { BrComService } from '../../service/BrComService';
import { PopoverController } from 'ionic-angular';
import { PushService } from '../../service/PushService';
import { LoadingController } from 'ionic-angular';
import { FotoProvider } from '../../providers/foto/foto';
import { HTTP } from '@ionic-native/http';
import { SpeechRecognition } from '@ionic-native/speech-recognition';
import { DatePipe } from '@angular/common';

var conversaPageInstance: ConversaPageWatson;
const NUM_MENSAGEM_REFRESH = 50;

interface RespostaWatson {
  nomeUsuario: string,
  response: string,
  nomeBot: string,
  dataHoraCriacao: string,
  idConversationMsg: string,
  conversationKey: string,
  operadorAssumir: boolean
}

interface ParametrosPrimeiraMensagem {
  workspaceId: string
}

interface ParametrosConversa {
  conversationId: string,
  text: string
}

interface Mensagem {
  nome: string,
  texto: string,
  data: string,
  tipo: TipoMensagem
}

enum TipoMensagem {
  usuario = "usuario",
  bot = "bot"
}

@Component({
  selector: 'page-conversa-watson',
  templateUrl: 'conversa.html'
})

export class ConversaPageWatson {

  @ViewChild(Content) content: Content;

  public texto = "";
  public nomeUsuario = "";
  public mensagens = [];
  public empresa;
  public quantidadeMensagensParaMostrar = NUM_MENSAGEM_REFRESH;
  public nomeCab;
  public urlImagem;
  public mensagem: any[]= [];
  
  private conversationKey: string;
  private codEmpresa: number;
  private codUsuarioFiltro: number;

  constructor(public lc: ChangeDetectorRef, public navCtrl: NavController, 
    private brComDao: BrComDao, private brComService: BrComService, navParams: NavParams, public events: Events, private pushService: PushService,
    public popoverCtrl: PopoverController, private fotoProvider: FotoProvider, private loadingCtrl: LoadingController, private http: HTTP,
    private speechRecognition: SpeechRecognition, private datePipe: DatePipe) {
    
    conversaPageInstance = this;
    this.codEmpresa = navParams.get("codEmpresa");
    conversaPageInstance.atualizaListaMensagens();
    this.empresa = brComService.obtemGrupoPorCodEmpresa(this.codEmpresa);
    events.subscribe("msg.empresa." + this.codEmpresa, this.msgRecebida);
    this.nomeCab = this.getNomeCab();
    this.urlImagem = this.obtemUrlImagemEmpresa(null);
    this.iniciarWatson();
  }

  private iniciarWatson():void {
    this.conversationKey = localStorage.getItem("conversationKey_"+this.codEmpresa);
    if (!this.conversationKey) {
      this.iniciarConversaComWatson();
    }
    this.atualizaListaMensagens();
  }

  ionViewWillEnter() {
    conversaPageInstance.brComService.confirmaUsuarioLogado(conversaPageInstance.empresa.CodEmpresa, conversaPageInstance.empresa.CodUsuario);
    conversaPageInstance.scrollBottom();
  }

  atualizaListaMensagens() {
    this.mensagens = JSON.parse(localStorage.getItem("conversaWatson_"+this.codEmpresa)) as Mensagem[];
  }

  adicionaMensagensAntigas(refresher) {
    setTimeout(() => {
      let newMaxMessages = conversaPageInstance.quantidadeMensagensParaMostrar + NUM_MENSAGEM_REFRESH;
      let sizeMessages = conversaPageInstance.brComDao.obtemMensagensEmpresa(conversaPageInstance.codEmpresa).length;

      if (conversaPageInstance.quantidadeMensagensParaMostrar == sizeMessages) {
        refresher.complete();
        return;
      }

      if (newMaxMessages > sizeMessages){
        newMaxMessages = sizeMessages
      }

      conversaPageInstance.quantidadeMensagensParaMostrar = newMaxMessages;
      conversaPageInstance.atualizaListaMensagens();
      refresher.complete();
    }, 1000);
  }

  detectaMudancas(){
      try {
        conversaPageInstance.lc.detectChanges();
      } catch (err) {
        console.log("desprezado erro em detectChanges ConversaPage");
      }
  }

  msgRecebida() {
    conversaPageInstance.detectaMudancas();
    conversaPageInstance.scrollBottom();
  }

  async enviar(mensagemUsuario: string) {
    this.scrollBottom();
    this.armazenarMensagemUsuario(mensagemUsuario);
    const mensagem = await this.enviarMensagemWatson({
      conversationId: localStorage.getItem("conversationKey_"+this.codEmpresa),
      text: mensagemUsuario
    });
    this.armazenarMensagemWatson(mensagem);
    this.msgRecebida();
  }

  goBack() {
    if (conversaPageInstance.codUsuarioFiltro) {
      conversaPageInstance.codUsuarioFiltro = null;
      conversaPageInstance.nomeUsuario = null;
      conversaPageInstance.nomeCab = conversaPageInstance.getNomeCab();
      conversaPageInstance.urlImagem = conversaPageInstance.obtemUrlImagemEmpresa(null);
      conversaPageInstance.atualizaListaMensagens();
      conversaPageInstance.scrollBottom();
    } else {
      conversaPageInstance.navCtrl.pop();
    }
  }

  scrollBottom() {
    setTimeout(function () {
      try {
        conversaPageInstance.content.scrollToBottom();
      } catch (e) {
        console.log('Igonorando conversaPageInstance.content inexistent');
      }
    }, 300);
  }

  onType(keyCode) {
    if (keyCode == 13) {
     // conversaPageInstance.enviar();
      conversaPageInstance.scrollBottom();
    }
  }

  abrirLink(link : any) {
    conversaPageInstance.brComService.abrePaginaComTipoURL(link);
  }

  abrirLinkHTML(link : any) {
    let load =  conversaPageInstance.loadingCtrl.create({content: "Aguarde ..."});
    load.present().then(
      ()=>{
        conversaPageInstance.brComService.iniciaPaginaNavegador(link);
        load.dismiss();
      }
    );
  }

  obtemUrlImagemEmpresa(m:any):string {
    if (conversaPageInstance.codUsuarioFiltro) {
      return conversaPageInstance.getImagemUsuario(m);
    } else {
      return this.fotoProvider.getUrlImagemServidor(this.obtemImagemEmpresa());
    }
  }

  obtemImagemEmpresa():string {
    let rec = conversaPageInstance.empresa;
    if (rec.HashLogotipoEmpresa)
      return rec.HashLogotipoEmpresa;
    else
      return "8db4380e774ad6f7e8c1aadb486b4290039cf0b7"; // logotipo InfoBr
  }

  getOrigemMsg(mensagem: Mensagem) {
    if (mensagem.tipo === TipoMensagem.usuario)
      return "right";
    else
      return "left";
  }

  public mostraTextoTipoMensagem(mensagem: any) {
    if (mensagem.origem == "L")
      return false;
    else
      return true;
  }

  responder(m: any) {
    if (!conversaPageInstance.codUsuarioFiltro){
      conversaPageInstance.codUsuarioFiltro = m.codUsuario;
      conversaPageInstance.nomeUsuario = m.nomeUsuario;
      conversaPageInstance.nomeCab = conversaPageInstance.getNomeCab();
      conversaPageInstance.urlImagem = conversaPageInstance.obtemUrlImagemEmpresa(m);
      conversaPageInstance.atualizaListaMensagens();
      conversaPageInstance.detectaMudancas();
    }
  }

  respondeMensagemAdmin(texto: string, codEmpresa: number, codUsuario: number) {
    conversaPageInstance.brComService.enviaMensagemTextoRespostaDoAdmin(codEmpresa, codUsuario, texto);
  }

  getImagemUsuario(m: any):string{
    if (m.hashLogotipo != "") 
      return this.fotoProvider.getUrlImagemServidor(m.hashLogotipo);
    else 
      return 'assets/img/usuario.png';
  }

  mostraResponder(tipo:string) {
    let rec = conversaPageInstance.empresa;
    if (rec.EhAdmin == 'F') {
      return false;
    } else if (conversaPageInstance.codUsuarioFiltro){
      return false;
    } else if (tipo == "R"){
      return true;
    }
  }

  mostraNomeUsuario(){
    if (conversaPageInstance.codUsuarioFiltro){
      return false;
    }
    return true;
  }

  getNomeCab() {
    let rec = conversaPageInstance.empresa;
    let st = "";
    if (conversaPageInstance.nomeUsuario) {
      st = conversaPageInstance.nomeUsuario
    }
    else if (rec.EhAdmin == 'V')
      st = rec.NomeEmpresa;
    else if (!st)
      st = rec.NomeEmpresa;
    return st;
  }

  private armazenarMensagemWatson(mensagemWatson: RespostaWatson): void {
    if (!mensagemWatson) {
      return;
    }
    const mensagem: Mensagem = {
      nome: mensagemWatson.nomeBot,
      texto: mensagemWatson.response,
      data: mensagemWatson.dataHoraCriacao,
      tipo: TipoMensagem.bot
    }
    this.armazenarMensagem(mensagem);
  }

  private armazenarMensagemUsuario(mensagemUsuario: string): void {
    const data = new Date().toDateString();
    const dataFormatada = this.datePipe.transform(data, "dd/MM/yyyy");
    const mensagem: Mensagem = {
      nome: this.nomeUsuario,
      texto: mensagemUsuario,
      data: dataFormatada,
      tipo: TipoMensagem.usuario
    }
    this.armazenarMensagem(mensagem);
  }

  private armazenarMensagem(mensagem: Mensagem): void {
    const mensagens = this.getMensagensWatson();
    mensagens.push(mensagem);
    this.armazenarConversaWatson(mensagens);
    this.atualizaListaMensagens();
  }

  private armazenarConversaWatson(mensagens: Mensagem[]): void {
    localStorage.setItem("conversaWatson_"+this.codEmpresa, JSON.stringify(mensagens));
  }

  private getMensagensWatson(): Mensagem[] {
    const mensagens = JSON.parse(localStorage.getItem("conversaWatson_"+this.codEmpresa));
    if (!mensagens) {
      return [];
    } 
    return mensagens
  }

  private async iniciarConversaComWatson(): Promise<void> {
    const resposta = await this.enviarMensagemWatson({workspaceId: "5ace2e85-c80f-46a8-bae6-13fd8dd1438c"});
    localStorage.setItem("conversationKey_"+this.codEmpresa, resposta.conversationKey);
    this.armazenarMensagemWatson(resposta);
  }

  public async enviarMensagemWatson(params: ParametrosPrimeiraMensagem | ParametrosConversa): Promise<RespostaWatson> {
    const URL = "http://167.99.238.102:8080/watson-orquestrador/remote/conversa/chamada";
    const HEADER = {'Content-Type': 'application/json'};
    const response = await this.http.get(URL, params, HEADER);
    if (!response.error) {
      const resultado = JSON.parse(response.data);
      return resultado.result;
    }
  }
  
  public abrirLinkWatson(evento: any): void {
    const href = evento.target.getAttribute('href');
    if (href) {
      evento.preventDefault();
      this.abrirLink(href);
    }
  }


}


// WEBPACK FOOTER //
// ./src/pages/conversaWatson/conversa.ts